/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnconfirmedGroupsRouteImport } from './routes/unconfirmed-groups'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ServiceRequestsRouteImport } from './routes/service-requests'
import { Route as MergeSuggestionsRouteImport } from './routes/merge-suggestions'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ItemsRouteImport } from './routes/items'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ItemsIndexRouteImport } from './routes/items/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SettingsTagsRouteImport } from './routes/settings/tags'
import { Route as SettingsSwitchOrganizationRouteImport } from './routes/settings/switch-organization'
import { Route as SettingsServiceRequestReasonsRouteImport } from './routes/settings/service-request-reasons'
import { Route as SettingsProductLineRouteImport } from './routes/settings/product-line'
import { Route as SettingsLocationsRouteImport } from './routes/settings/locations'
import { Route as SettingsCategoryRouteImport } from './routes/settings/category'
import { Route as SettingsBrandRouteImport } from './routes/settings/brand'
import { Route as ItemsCreateRouteImport } from './routes/items/create'
import { Route as AdminPromoteGlobalRouteImport } from './routes/admin/promote-global'
import { Route as AdminPermissionsRouteImport } from './routes/admin/permissions'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AdminInventoryOverviewRouteImport } from './routes/admin/inventory-overview'
import { Route as AdminIngestRouteImport } from './routes/admin/ingest'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin/feature-flags'
import { Route as AdminDataCleanupRouteImport } from './routes/admin/data-cleanup'
import { Route as AdminCleanupRouteImport } from './routes/admin/cleanup'
import { Route as AdminApiKeysRouteImport } from './routes/admin/api-keys'
import { Route as AdminAlgoliaRouteImport } from './routes/admin/algolia'
import { Route as AdminAiMetricsRouteImport } from './routes/admin/ai-metrics'
import { Route as SettingsAttributesIndexRouteImport } from './routes/settings/attributes.index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings.index'
import { Route as SettingsAttributesCategoryIdRouteImport } from './routes/settings/attributes.$categoryId'
import { Route as ItemsAssetGroupIdMergeRouteImport } from './routes/items/$assetGroupId.merge'
import { Route as ItemsAssetGroupIdEditRouteImport } from './routes/items/$assetGroupId.edit'
import { Route as CdnCgiAccessAuthorizedRouteImport } from './routes/cdn-cgi/access/authorized'
import { Route as AdminIngestOriginRouteImport } from './routes/admin/ingest_.$origin'
import { Route as AdminIngestOriginPayloadsIdRouteImport } from './routes/admin/ingest_.$origin.payloads.$id'

const UnconfirmedGroupsRoute = UnconfirmedGroupsRouteImport.update({
  id: '/unconfirmed-groups',
  path: '/unconfirmed-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceRequestsRoute = ServiceRequestsRouteImport.update({
  id: '/service-requests',
  path: '/service-requests',
  getParentRoute: () => rootRouteImport,
} as any)
const MergeSuggestionsRoute = MergeSuggestionsRouteImport.update({
  id: '/merge-suggestions',
  path: '/merge-suggestions',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ItemsRoute = ItemsRouteImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const ItemsIndexRoute = ItemsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ItemsRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SettingsTagsRoute = SettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSwitchOrganizationRoute =
  SettingsSwitchOrganizationRouteImport.update({
    id: '/switch-organization',
    path: '/switch-organization',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsServiceRequestReasonsRoute =
  SettingsServiceRequestReasonsRouteImport.update({
    id: '/service-request-reasons',
    path: '/service-request-reasons',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsProductLineRoute = SettingsProductLineRouteImport.update({
  id: '/product-line',
  path: '/product-line',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCategoryRoute = SettingsCategoryRouteImport.update({
  id: '/category',
  path: '/category',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBrandRoute = SettingsBrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => SettingsRoute,
} as any)
const ItemsCreateRoute = ItemsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => ItemsRoute,
} as any)
const AdminPromoteGlobalRoute = AdminPromoteGlobalRouteImport.update({
  id: '/promote-global',
  path: '/promote-global',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPermissionsRoute = AdminPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInventoryOverviewRoute = AdminInventoryOverviewRouteImport.update({
  id: '/inventory-overview',
  path: '/inventory-overview',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIngestRoute = AdminIngestRouteImport.update({
  id: '/ingest',
  path: '/ingest',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDataCleanupRoute = AdminDataCleanupRouteImport.update({
  id: '/data-cleanup',
  path: '/data-cleanup',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCleanupRoute = AdminCleanupRouteImport.update({
  id: '/cleanup',
  path: '/cleanup',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAlgoliaRoute = AdminAlgoliaRouteImport.update({
  id: '/algolia',
  path: '/algolia',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAiMetricsRoute = AdminAiMetricsRouteImport.update({
  id: '/ai-metrics',
  path: '/ai-metrics',
  getParentRoute: () => AdminRoute,
} as any)
const SettingsAttributesIndexRoute = SettingsAttributesIndexRouteImport.update({
  id: '/attributes/',
  path: '/attributes/',
  getParentRoute: () => SettingsRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any)
const SettingsAttributesCategoryIdRoute =
  SettingsAttributesCategoryIdRouteImport.update({
    id: '/attributes/$categoryId',
    path: '/attributes/$categoryId',
    getParentRoute: () => SettingsRoute,
  } as any)
const ItemsAssetGroupIdMergeRoute = ItemsAssetGroupIdMergeRouteImport.update({
  id: '/$assetGroupId/merge',
  path: '/$assetGroupId/merge',
  getParentRoute: () => ItemsRoute,
} as any)
const ItemsAssetGroupIdEditRoute = ItemsAssetGroupIdEditRouteImport.update({
  id: '/$assetGroupId/edit',
  path: '/$assetGroupId/edit',
  getParentRoute: () => ItemsRoute,
} as any)
const CdnCgiAccessAuthorizedRoute = CdnCgiAccessAuthorizedRouteImport.update({
  id: '/cdn-cgi/access/authorized',
  path: '/cdn-cgi/access/authorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIngestOriginRoute = AdminIngestOriginRouteImport.update({
  id: '/ingest_/$origin',
  path: '/ingest/$origin',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIngestOriginPayloadsIdRoute =
  AdminIngestOriginPayloadsIdRouteImport.update({
    id: '/payloads/$id',
    path: '/payloads/$id',
    getParentRoute: () => AdminIngestOriginRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/items': typeof ItemsRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/merge-suggestions': typeof MergeSuggestionsRoute
  '/service-requests': typeof ServiceRequestsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/unconfirmed-groups': typeof UnconfirmedGroupsRoute
  '/admin/ai-metrics': typeof AdminAiMetricsRoute
  '/admin/algolia': typeof AdminAlgoliaRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/cleanup': typeof AdminCleanupRoute
  '/admin/data-cleanup': typeof AdminDataCleanupRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/ingest': typeof AdminIngestRoute
  '/admin/inventory-overview': typeof AdminInventoryOverviewRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/promote-global': typeof AdminPromoteGlobalRoute
  '/items/create': typeof ItemsCreateRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/category': typeof SettingsCategoryRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/product-line': typeof SettingsProductLineRoute
  '/settings/service-request-reasons': typeof SettingsServiceRequestReasonsRoute
  '/settings/switch-organization': typeof SettingsSwitchOrganizationRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/admin/': typeof AdminIndexRoute
  '/items/': typeof ItemsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/admin/ingest/$origin': typeof AdminIngestOriginRouteWithChildren
  '/cdn-cgi/access/authorized': typeof CdnCgiAccessAuthorizedRoute
  '/items/$assetGroupId/edit': typeof ItemsAssetGroupIdEditRoute
  '/items/$assetGroupId/merge': typeof ItemsAssetGroupIdMergeRoute
  '/settings/attributes/$categoryId': typeof SettingsAttributesCategoryIdRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/settings/attributes': typeof SettingsAttributesIndexRoute
  '/admin/ingest/$origin/payloads/$id': typeof AdminIngestOriginPayloadsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/merge-suggestions': typeof MergeSuggestionsRoute
  '/service-requests': typeof ServiceRequestsRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/unconfirmed-groups': typeof UnconfirmedGroupsRoute
  '/admin/ai-metrics': typeof AdminAiMetricsRoute
  '/admin/algolia': typeof AdminAlgoliaRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/cleanup': typeof AdminCleanupRoute
  '/admin/data-cleanup': typeof AdminDataCleanupRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/ingest': typeof AdminIngestRoute
  '/admin/inventory-overview': typeof AdminInventoryOverviewRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/promote-global': typeof AdminPromoteGlobalRoute
  '/items/create': typeof ItemsCreateRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/category': typeof SettingsCategoryRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/product-line': typeof SettingsProductLineRoute
  '/settings/service-request-reasons': typeof SettingsServiceRequestReasonsRoute
  '/settings/switch-organization': typeof SettingsSwitchOrganizationRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/admin': typeof AdminIndexRoute
  '/items': typeof ItemsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/admin/ingest/$origin': typeof AdminIngestOriginRouteWithChildren
  '/cdn-cgi/access/authorized': typeof CdnCgiAccessAuthorizedRoute
  '/items/$assetGroupId/edit': typeof ItemsAssetGroupIdEditRoute
  '/items/$assetGroupId/merge': typeof ItemsAssetGroupIdMergeRoute
  '/settings/attributes/$categoryId': typeof SettingsAttributesCategoryIdRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/settings/attributes': typeof SettingsAttributesIndexRoute
  '/admin/ingest/$origin/payloads/$id': typeof AdminIngestOriginPayloadsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/items': typeof ItemsRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/merge-suggestions': typeof MergeSuggestionsRoute
  '/service-requests': typeof ServiceRequestsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/unconfirmed-groups': typeof UnconfirmedGroupsRoute
  '/admin/ai-metrics': typeof AdminAiMetricsRoute
  '/admin/algolia': typeof AdminAlgoliaRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/cleanup': typeof AdminCleanupRoute
  '/admin/data-cleanup': typeof AdminDataCleanupRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/ingest': typeof AdminIngestRoute
  '/admin/inventory-overview': typeof AdminInventoryOverviewRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/permissions': typeof AdminPermissionsRoute
  '/admin/promote-global': typeof AdminPromoteGlobalRoute
  '/items/create': typeof ItemsCreateRoute
  '/settings/brand': typeof SettingsBrandRoute
  '/settings/category': typeof SettingsCategoryRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/product-line': typeof SettingsProductLineRoute
  '/settings/service-request-reasons': typeof SettingsServiceRequestReasonsRoute
  '/settings/switch-organization': typeof SettingsSwitchOrganizationRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/admin/': typeof AdminIndexRoute
  '/items/': typeof ItemsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/admin/ingest_/$origin': typeof AdminIngestOriginRouteWithChildren
  '/cdn-cgi/access/authorized': typeof CdnCgiAccessAuthorizedRoute
  '/items/$assetGroupId/edit': typeof ItemsAssetGroupIdEditRoute
  '/items/$assetGroupId/merge': typeof ItemsAssetGroupIdMergeRoute
  '/settings/attributes/$categoryId': typeof SettingsAttributesCategoryIdRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/settings/attributes/': typeof SettingsAttributesIndexRoute
  '/admin/ingest_/$origin/payloads/$id': typeof AdminIngestOriginPayloadsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/items'
    | '/login'
    | '/logout'
    | '/merge-suggestions'
    | '/service-requests'
    | '/settings'
    | '/unauthorized'
    | '/unconfirmed-groups'
    | '/admin/ai-metrics'
    | '/admin/algolia'
    | '/admin/api-keys'
    | '/admin/cleanup'
    | '/admin/data-cleanup'
    | '/admin/feature-flags'
    | '/admin/ingest'
    | '/admin/inventory-overview'
    | '/admin/organizations'
    | '/admin/permissions'
    | '/admin/promote-global'
    | '/items/create'
    | '/settings/brand'
    | '/settings/category'
    | '/settings/locations'
    | '/settings/product-line'
    | '/settings/service-request-reasons'
    | '/settings/switch-organization'
    | '/settings/tags'
    | '/admin/'
    | '/items/'
    | '/settings/'
    | '/admin/ingest/$origin'
    | '/cdn-cgi/access/authorized'
    | '/items/$assetGroupId/edit'
    | '/items/$assetGroupId/merge'
    | '/settings/attributes/$categoryId'
    | '/admin/settings'
    | '/settings/attributes'
    | '/admin/ingest/$origin/payloads/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/logout'
    | '/merge-suggestions'
    | '/service-requests'
    | '/unauthorized'
    | '/unconfirmed-groups'
    | '/admin/ai-metrics'
    | '/admin/algolia'
    | '/admin/api-keys'
    | '/admin/cleanup'
    | '/admin/data-cleanup'
    | '/admin/feature-flags'
    | '/admin/ingest'
    | '/admin/inventory-overview'
    | '/admin/organizations'
    | '/admin/permissions'
    | '/admin/promote-global'
    | '/items/create'
    | '/settings/brand'
    | '/settings/category'
    | '/settings/locations'
    | '/settings/product-line'
    | '/settings/service-request-reasons'
    | '/settings/switch-organization'
    | '/settings/tags'
    | '/admin'
    | '/items'
    | '/settings'
    | '/admin/ingest/$origin'
    | '/cdn-cgi/access/authorized'
    | '/items/$assetGroupId/edit'
    | '/items/$assetGroupId/merge'
    | '/settings/attributes/$categoryId'
    | '/admin/settings'
    | '/settings/attributes'
    | '/admin/ingest/$origin/payloads/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/items'
    | '/login'
    | '/logout'
    | '/merge-suggestions'
    | '/service-requests'
    | '/settings'
    | '/unauthorized'
    | '/unconfirmed-groups'
    | '/admin/ai-metrics'
    | '/admin/algolia'
    | '/admin/api-keys'
    | '/admin/cleanup'
    | '/admin/data-cleanup'
    | '/admin/feature-flags'
    | '/admin/ingest'
    | '/admin/inventory-overview'
    | '/admin/organizations'
    | '/admin/permissions'
    | '/admin/promote-global'
    | '/items/create'
    | '/settings/brand'
    | '/settings/category'
    | '/settings/locations'
    | '/settings/product-line'
    | '/settings/service-request-reasons'
    | '/settings/switch-organization'
    | '/settings/tags'
    | '/admin/'
    | '/items/'
    | '/settings/'
    | '/admin/ingest_/$origin'
    | '/cdn-cgi/access/authorized'
    | '/items/$assetGroupId/edit'
    | '/items/$assetGroupId/merge'
    | '/settings/attributes/$categoryId'
    | '/admin/settings/'
    | '/settings/attributes/'
    | '/admin/ingest_/$origin/payloads/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ItemsRoute: typeof ItemsRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  MergeSuggestionsRoute: typeof MergeSuggestionsRoute
  ServiceRequestsRoute: typeof ServiceRequestsRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  UnauthorizedRoute: typeof UnauthorizedRoute
  UnconfirmedGroupsRoute: typeof UnconfirmedGroupsRoute
  CdnCgiAccessAuthorizedRoute: typeof CdnCgiAccessAuthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unconfirmed-groups': {
      id: '/unconfirmed-groups'
      path: '/unconfirmed-groups'
      fullPath: '/unconfirmed-groups'
      preLoaderRoute: typeof UnconfirmedGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service-requests': {
      id: '/service-requests'
      path: '/service-requests'
      fullPath: '/service-requests'
      preLoaderRoute: typeof ServiceRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merge-suggestions': {
      id: '/merge-suggestions'
      path: '/merge-suggestions'
      fullPath: '/merge-suggestions'
      preLoaderRoute: typeof MergeSuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/items': {
      id: '/items'
      path: '/items'
      fullPath: '/items'
      preLoaderRoute: typeof ItemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/items/': {
      id: '/items/'
      path: '/'
      fullPath: '/items/'
      preLoaderRoute: typeof ItemsIndexRouteImport
      parentRoute: typeof ItemsRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/settings/tags': {
      id: '/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof SettingsTagsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/switch-organization': {
      id: '/settings/switch-organization'
      path: '/switch-organization'
      fullPath: '/settings/switch-organization'
      preLoaderRoute: typeof SettingsSwitchOrganizationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/service-request-reasons': {
      id: '/settings/service-request-reasons'
      path: '/service-request-reasons'
      fullPath: '/settings/service-request-reasons'
      preLoaderRoute: typeof SettingsServiceRequestReasonsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/product-line': {
      id: '/settings/product-line'
      path: '/product-line'
      fullPath: '/settings/product-line'
      preLoaderRoute: typeof SettingsProductLineRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/locations': {
      id: '/settings/locations'
      path: '/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof SettingsLocationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/category': {
      id: '/settings/category'
      path: '/category'
      fullPath: '/settings/category'
      preLoaderRoute: typeof SettingsCategoryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/brand': {
      id: '/settings/brand'
      path: '/brand'
      fullPath: '/settings/brand'
      preLoaderRoute: typeof SettingsBrandRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/items/create': {
      id: '/items/create'
      path: '/create'
      fullPath: '/items/create'
      preLoaderRoute: typeof ItemsCreateRouteImport
      parentRoute: typeof ItemsRoute
    }
    '/admin/promote-global': {
      id: '/admin/promote-global'
      path: '/promote-global'
      fullPath: '/admin/promote-global'
      preLoaderRoute: typeof AdminPromoteGlobalRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/permissions': {
      id: '/admin/permissions'
      path: '/permissions'
      fullPath: '/admin/permissions'
      preLoaderRoute: typeof AdminPermissionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/inventory-overview': {
      id: '/admin/inventory-overview'
      path: '/inventory-overview'
      fullPath: '/admin/inventory-overview'
      preLoaderRoute: typeof AdminInventoryOverviewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ingest': {
      id: '/admin/ingest'
      path: '/ingest'
      fullPath: '/admin/ingest'
      preLoaderRoute: typeof AdminIngestRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/data-cleanup': {
      id: '/admin/data-cleanup'
      path: '/data-cleanup'
      fullPath: '/admin/data-cleanup'
      preLoaderRoute: typeof AdminDataCleanupRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/cleanup': {
      id: '/admin/cleanup'
      path: '/cleanup'
      fullPath: '/admin/cleanup'
      preLoaderRoute: typeof AdminCleanupRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/api-keys': {
      id: '/admin/api-keys'
      path: '/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AdminApiKeysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/algolia': {
      id: '/admin/algolia'
      path: '/algolia'
      fullPath: '/admin/algolia'
      preLoaderRoute: typeof AdminAlgoliaRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ai-metrics': {
      id: '/admin/ai-metrics'
      path: '/ai-metrics'
      fullPath: '/admin/ai-metrics'
      preLoaderRoute: typeof AdminAiMetricsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/settings/attributes/': {
      id: '/settings/attributes/'
      path: '/attributes'
      fullPath: '/settings/attributes'
      preLoaderRoute: typeof SettingsAttributesIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/settings/attributes/$categoryId': {
      id: '/settings/attributes/$categoryId'
      path: '/attributes/$categoryId'
      fullPath: '/settings/attributes/$categoryId'
      preLoaderRoute: typeof SettingsAttributesCategoryIdRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/items/$assetGroupId/merge': {
      id: '/items/$assetGroupId/merge'
      path: '/$assetGroupId/merge'
      fullPath: '/items/$assetGroupId/merge'
      preLoaderRoute: typeof ItemsAssetGroupIdMergeRouteImport
      parentRoute: typeof ItemsRoute
    }
    '/items/$assetGroupId/edit': {
      id: '/items/$assetGroupId/edit'
      path: '/$assetGroupId/edit'
      fullPath: '/items/$assetGroupId/edit'
      preLoaderRoute: typeof ItemsAssetGroupIdEditRouteImport
      parentRoute: typeof ItemsRoute
    }
    '/cdn-cgi/access/authorized': {
      id: '/cdn-cgi/access/authorized'
      path: '/cdn-cgi/access/authorized'
      fullPath: '/cdn-cgi/access/authorized'
      preLoaderRoute: typeof CdnCgiAccessAuthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ingest_/$origin': {
      id: '/admin/ingest_/$origin'
      path: '/ingest/$origin'
      fullPath: '/admin/ingest/$origin'
      preLoaderRoute: typeof AdminIngestOriginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ingest_/$origin/payloads/$id': {
      id: '/admin/ingest_/$origin/payloads/$id'
      path: '/payloads/$id'
      fullPath: '/admin/ingest/$origin/payloads/$id'
      preLoaderRoute: typeof AdminIngestOriginPayloadsIdRouteImport
      parentRoute: typeof AdminIngestOriginRoute
    }
  }
}

interface AdminIngestOriginRouteChildren {
  AdminIngestOriginPayloadsIdRoute: typeof AdminIngestOriginPayloadsIdRoute
}

const AdminIngestOriginRouteChildren: AdminIngestOriginRouteChildren = {
  AdminIngestOriginPayloadsIdRoute: AdminIngestOriginPayloadsIdRoute,
}

const AdminIngestOriginRouteWithChildren =
  AdminIngestOriginRoute._addFileChildren(AdminIngestOriginRouteChildren)

interface AdminRouteChildren {
  AdminAiMetricsRoute: typeof AdminAiMetricsRoute
  AdminAlgoliaRoute: typeof AdminAlgoliaRoute
  AdminApiKeysRoute: typeof AdminApiKeysRoute
  AdminCleanupRoute: typeof AdminCleanupRoute
  AdminDataCleanupRoute: typeof AdminDataCleanupRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminIngestRoute: typeof AdminIngestRoute
  AdminInventoryOverviewRoute: typeof AdminInventoryOverviewRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminPermissionsRoute: typeof AdminPermissionsRoute
  AdminPromoteGlobalRoute: typeof AdminPromoteGlobalRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminIngestOriginRoute: typeof AdminIngestOriginRouteWithChildren
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAiMetricsRoute: AdminAiMetricsRoute,
  AdminAlgoliaRoute: AdminAlgoliaRoute,
  AdminApiKeysRoute: AdminApiKeysRoute,
  AdminCleanupRoute: AdminCleanupRoute,
  AdminDataCleanupRoute: AdminDataCleanupRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminIngestRoute: AdminIngestRoute,
  AdminInventoryOverviewRoute: AdminInventoryOverviewRoute,
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminPermissionsRoute: AdminPermissionsRoute,
  AdminPromoteGlobalRoute: AdminPromoteGlobalRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminIngestOriginRoute: AdminIngestOriginRouteWithChildren,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ItemsRouteChildren {
  ItemsCreateRoute: typeof ItemsCreateRoute
  ItemsIndexRoute: typeof ItemsIndexRoute
  ItemsAssetGroupIdEditRoute: typeof ItemsAssetGroupIdEditRoute
  ItemsAssetGroupIdMergeRoute: typeof ItemsAssetGroupIdMergeRoute
}

const ItemsRouteChildren: ItemsRouteChildren = {
  ItemsCreateRoute: ItemsCreateRoute,
  ItemsIndexRoute: ItemsIndexRoute,
  ItemsAssetGroupIdEditRoute: ItemsAssetGroupIdEditRoute,
  ItemsAssetGroupIdMergeRoute: ItemsAssetGroupIdMergeRoute,
}

const ItemsRouteWithChildren = ItemsRoute._addFileChildren(ItemsRouteChildren)

interface SettingsRouteChildren {
  SettingsBrandRoute: typeof SettingsBrandRoute
  SettingsCategoryRoute: typeof SettingsCategoryRoute
  SettingsLocationsRoute: typeof SettingsLocationsRoute
  SettingsProductLineRoute: typeof SettingsProductLineRoute
  SettingsServiceRequestReasonsRoute: typeof SettingsServiceRequestReasonsRoute
  SettingsSwitchOrganizationRoute: typeof SettingsSwitchOrganizationRoute
  SettingsTagsRoute: typeof SettingsTagsRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SettingsAttributesCategoryIdRoute: typeof SettingsAttributesCategoryIdRoute
  SettingsAttributesIndexRoute: typeof SettingsAttributesIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsBrandRoute: SettingsBrandRoute,
  SettingsCategoryRoute: SettingsCategoryRoute,
  SettingsLocationsRoute: SettingsLocationsRoute,
  SettingsProductLineRoute: SettingsProductLineRoute,
  SettingsServiceRequestReasonsRoute: SettingsServiceRequestReasonsRoute,
  SettingsSwitchOrganizationRoute: SettingsSwitchOrganizationRoute,
  SettingsTagsRoute: SettingsTagsRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsAttributesCategoryIdRoute: SettingsAttributesCategoryIdRoute,
  SettingsAttributesIndexRoute: SettingsAttributesIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ItemsRoute: ItemsRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  MergeSuggestionsRoute: MergeSuggestionsRoute,
  ServiceRequestsRoute: ServiceRequestsRoute,
  SettingsRoute: SettingsRouteWithChildren,
  UnauthorizedRoute: UnauthorizedRoute,
  UnconfirmedGroupsRoute: UnconfirmedGroupsRoute,
  CdnCgiAccessAuthorizedRoute: CdnCgiAccessAuthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
